import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getParties } from "../../services/services";

// Fetch Parties
export const fetchParties = createAsyncThunk(
  "party/fetchParties",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await getParties(filters);
      return response.data.response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch parties",
      );
    }
  },
);

const partySlice = createSlice({
  name: "party",
  initialState: {
    list: [],
    loading: false,
    error: null,
    page: 1,
    totalPages: 1,
  },
  reducers: {
    clearParties: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchParties.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchParties.fulfilled, (state, action) => {
        state.loading = false;

        const page = action.meta.arg?.page || 1;
        const newParties = action.payload?.parties || [];

        if (page === 1) {
          state.list = newParties;
        } else {
          state.list = [...state.list, ...newParties];
        }
      })
      .addCase(fetchParties.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearParties } = partySlice.actions;
export default partySlice.reducer;

// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { getParties } from "../../services/services";

// // Fetch Parties
// export const fetchParties = createAsyncThunk(
//   "party/fetchParties",
//   async (filters = {}, { rejectWithValue }) => {
//     try {
//       const response = await getParties(filters);

//       return {
//         parties: response.data.response.parties,
//         page: response.data.page,
//         totalPages: response.data.totalPages,
//       };
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to fetch parties"
//       );
//     }
//   }
// );

// const partySlice = createSlice({
//   name: "party",
//   initialState: {
//     list: [],
//     page: 1,
//     totalPages: 1,
//     loading: false,
//     error: null,
//   },
//   reducers: {
//     clearParties: (state) => {
//       state.list = [];
//       state.page = 1;
//       state.totalPages = 1;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchParties.pending, (state) => {
//         state.loading = true;
//       })

//       .addCase(fetchParties.fulfilled, (state, action) => {
//         state.loading = false;

//         const { parties, page, totalPages } = action.payload;

//         // append for infinite scroll
//         if (page > 1) {
//           state.list = [...state.list, ...parties];
//         } else {
//           state.list = parties;
//         }

//         state.page = page;
//         state.totalPages = totalPages;
//       })

//       .addCase(fetchParties.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { clearParties } = partySlice.actions;
// export default partySlice.reducer;
